import React from "react";

import AssetLink from "components/AssetLink";
import "./EventItem.scss";

const EventItem = React.memo(({ title, assets }) => {
  // console.log("EventItem", title, assets);
  return (
    <section className="EventItem section is-desktop">
      <div className="card">
        <header className="card-header has-background-primary">
          <p className="card-header-title is-centered is-size-4">{title}</p>
        </header>
        <div className="card-content">
          <div className="content">
            <ul className="is-flex is-flex-direction-column is-align-items-center">
              {assets.map((asset, i) => (
                <li key={i}>
                  <AssetLink {...asset} />
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
});

export default EventItem;
